import axios from 'api/axios'
import { notifyError } from 'ui/components/Notify'

const makeRequest = async (config = {}) => {
  try {
    return await axios(config)
  } catch (error) {
    const httpStatus = error?.response?.status
    const code = httpStatus || 500
    const isCanceled =
      error?.code === 'ERR_CANCELED' || error?.message === 'canceled'

    if (code === 500 && !isCanceled) {
      notifyError('500. Ошибка на сервере.')
    }

    return {
      ...error?.response,
      code: httpStatus,
      status: httpStatus,
      errorMessage: `${code}: ${error?.message}`,
    }
  }
}

export default makeRequest
